/* istanbul ignore file */
import React, { PureComponent } from "react";

import { Credentials } from "auth";

export interface ZenDeskProps {
    zendeskKey?: string;
    credentials?: Credentials;
    apiUrl?: string;
}

export class ZenDeskWidget extends PureComponent<ZenDeskProps, {}> {
    private credentials: boolean;

    private zendeskKey: string;

    private apiUrl: string;

    constructor(props: ZenDeskProps) {
        super(props);

        this.zendeskKey = props.zendeskKey;
        this.apiUrl = props.apiUrl;

        if (props.credentials && this.zendeskKey) {
            this.credentials = true;
            this.initZenDeskWidget(props.credentials);
        }
    }

    componentWillReceiveProps(props: ZenDeskProps) {
        if (props.credentials && !this.credentials) {
            this.credentials = true;
            this.initZenDeskWidget(props.credentials);
        }
    }

    initZenDeskWidget(credentials: Credentials) {
        const jwtFn = credentials
            ? async (callback: any) => {
                const zendeskToken = await fetch(`${this.apiUrl}/users/zendesk`, {
                    headers: { "x-xapp-usertoken": credentials.accessToken }
                }).then((response: any) => response.json());

                callback(zendeskToken.token);
            }
            : undefined;

        /** Begin ZenDesk Auth */
        // @ts-ignore
        window.zESettings = {
            webWidget: {
                authenticate: {
                    chat: {
                        jwtFn
                    }
                }
            }
        };

        const zenDeskScript = document.createElement("script");
        /**
         * <!-- Start of xapp Zendesk Widget script -->
            <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key={key}"> </script>
            <!-- End of xapp Zendesk Widget script -->
         */
        zenDeskScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${this.zendeskKey}`;
        zenDeskScript.id = "ze-snippet";
        document.getElementsByTagName("head")[0].appendChild(zenDeskScript);
        /** End ZenDesk Auth */
    }

    render() {
        return <></>;
    }
}
